import React, { Fragment, useState, useCallback, useEffect } from 'react';
import { usePrevious } from 'react-use';
import isUndefined from 'lodash/isUndefined';
import capitalize from 'lodash/capitalize';
import PropTypes from 'prop-types';
import SlidingImage from './SlidingImage';

const SlidingGallery = ({ selected, images, imageSize, height }) => {
  const [direction, setDirection] = useState();
  const [upcoming, setUpcoming] = useState();
  const [current, setCurrent] = useState(selected);
  const prevSelected = usePrevious(selected);

  useEffect(() => {
    const selectedIndex = selected?.index;
    const previousIndex = prevSelected?.index;
    if (!isUndefined(selectedIndex) && !isUndefined(previousIndex) && prevSelected && selectedIndex !== previousIndex) {
      let newDirection = selectedIndex > previousIndex ? 'Left' : 'Right';
      const navigatedToLastImage = previousIndex === images.length - 1 && selectedIndex === 0;
      const navigatedToFirstImage = previousIndex === 0 && selectedIndex === images.length - 1;
      if (navigatedToFirstImage) {
        newDirection = 'Right';
      } else if (navigatedToLastImage) {
        newDirection = 'Left';
      }
      setDirection(newDirection);
      setUpcoming({ index: selectedIndex, ...images[selectedIndex] });
    }
  }, [selected, prevSelected, images, setDirection, setUpcoming]);

  const onSlideAnimationComplete = useCallback(() => {
    setCurrent(upcoming);
  }, [setCurrent, upcoming]);

  const onSlidingImageLoaded = useCallback(() => {
    setDirection(undefined);
  }, [setDirection]);

  const urlSize = `url${capitalize(imageSize)}`;

  return (
    <Fragment>
      <SlidingImage
        data-testid="sliding-gallery-upcoming-image"
        open={!!direction}
        src={upcoming ? upcoming[urlSize] : undefined}
        alt={upcoming?.caption}
        direction={direction ? `slide${direction}In` : undefined}
        height={height}
      />
      <SlidingImage
        data-testid="sliding-gallery-current-image"
        open={!direction}
        src={current[urlSize]}
        alt={current.caption}
        direction={direction ? `slide${direction}Out` : undefined}
        onAnimationComplete={onSlideAnimationComplete}
        onImageLoaded={onSlidingImageLoaded}
        height={height}
      />
    </Fragment>
  );
};

SlidingGallery.propTypes = {
  images: PropTypes.array.isRequired,
  selected: PropTypes.object,
  height: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  imageSize: PropTypes.oneOf(['small', 'medium', 'large']).isRequired,
};

SlidingGallery.defaultProps = {
  selected: {},
  height: undefined,
};

export default SlidingGallery;
